import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import ProductListCard from '../Shared/ProductListCard';
import TextInput from '../Shared/TextInput';
import TextArea from '../Shared/TextArea';
import LoadingButton from '../Shared/LoadingButton';
import MapDisplay from './Components/MapDisplay';
import Icon from '../Shared/Icon';
import classNames from 'classnames';

const Contact = () => {
     const { app, auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          name: '',
          email: '',
          sujet: '',
          message: '',
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('site.post.contact'), values).then(() => {
               setSending(false);
               setValues(values => ({
                    ...values,
                    name: '',
                    email: '',
                    sujet: '',
                    message: ''
               }));
          });
     }

     return (
          <React.Fragment>
               <Helmet>
                    <title>{data.caption.contact}</title>
               </Helmet>
               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto">
                         <div className="w-full mt-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-800">{data.caption.divisions}</h1>
                         </div>
                         <div className="mt-5 grid grid-cols-2 md:grid-cols-3 gap-5 mb-10">
                              {data.affiliates.map(({name, logo, description, website},i) => {
                                   return <a key={`aff-${i}`} className="w-full flex flex-col text-gray-600 hover:text-emerald-500" href={website?website:'#'} target="_blank">
                                        <div className="w-full rounded hover:shadow-lg focus:shadow-lg p-2 items-center">
                                             <div className="w-1/2 mx-auto">
                                                  <img src={logo} alt={name} className="mx-auto object-contain" />
                                             </div>
                                             <div className="w-full mx-auto">
                                                  <h2 className="text-xs md:text-md text-emerald-600 text-center uppercase font-medium">{name}</h2>
                                                  <p className="hidden md:block text-sm text-gray-500 text-center">{description}</p>
                                             </div>
                                        </div>
                                   </a>
                              })}
                         </div>
                    </div>
               </section>

               <section className="w-full bg-gray-200 pt-10 pb-10">
                    <div className="container mx-auto py-10">
                         <div className="sm:flex md:grid grid-cols-2 gap-5">
                              <div className="px-4 border-b border-gray-400 md:border-0 pb-4 mb-4 md:pb-0 md:mb-0">
                                   <h2 className="text-lg uppercase font-medium text-yellow-600">{data.caption.contact}</h2>
                                   <form onSubmit={handleSubmit}>
                                        <div className="flex">
                                             <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 w-1/2 mr-1"
                                                   label={data.caption.name}
                                                   name="name"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   must={true}
                                                   errors={errors.name}
                                                   value={values.name}
                                                   onChange={handleChange}
                                              />
                                              <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 w-1/2"
                                                   label={data.caption.email}
                                                   name="email"
                                                   type="email"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.email}
                                                   value={values.email}
                                                   onChange={handleChange}
                                              />
                                        </div>
                                         <TextInput
                                              className="form-input rounded-md shadow-sm mt-4 w-full"
                                              label={data.caption.subject}
                                              name="sujet"
                                              type="text"
                                              disable={false}
                                              readonly={false}
                                              must={true}
                                              errors={errors.sujet}
                                              value={values.sujet}
                                              onChange={handleChange}
                                         />
                                         <TextArea
                                             className="form-input rounded-md mt-4 block w-full"
                                             label={data.caption.message}
                                             name="message"
                                             must={true}
                                             errors={errors.message}
                                             value={values.message}
                                             onChange={handleChange}
                                        />
                                        <div className="flex items-center justify-end px-4 py-3 text-right sm:px-6 rounded-b">
                                             <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                                  {data.caption.send}
                                             </LoadingButton>
                                        </div>
                                   </form>
                              </div>
                              <div className="px-3">
                                   <h2 className="text-lg uppercase font-medium text-center text-yellow-600">LA MAISON HENRI DESCHAMPS</h2>
                                   <h3 className="mx-auto text-md lg:text-lg italic text-center text-emerald-700">{data.caption.mhd_subtitle}</h3>
                                   <p className="mt-5 text-gray-700 text-justify">{data.caption.mhd_content}</p>
                                   <h2 className="text-lg uppercase font-medium text-yellow-600 mt-5">Contact</h2>
                                   <p className="mt-5 text-yellow-600 flex items-center">
                                        <span className="p-2 mr-2 rounded-full border-emerald-600 border-2"><Icon name={'location'} className={'fill-current text-emerald-600 w-6 h-6'} /></span> {app.address}
                                   </p>
                                   <p className="mt-5 text-yellow-600 flex items-center">
                                        <span className="p-2 mr-2 rounded-full border-emerald-600 border-2"><Icon name={'phone'} className={'fill-current text-emerald-600 w-6 h-6'} /></span> {app.phone} / +509 2813-0216
                                   </p>
                              </div>
                         </div>
                    </div>
               </section>

               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto pt-10 pb-10">
                         <div className="w-full mt-10">
                              <h1 className="text-center font-bold text-lg uppercase text-emerald-600">{data.caption.pos}</h1>
                         </div>
                         <div className="mt-5 w-full" style={{height: `790px`}}>
                              <MapDisplay />
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Contact.layout = page => <SiteLayout children={page} header={'Contact'} />;

export default Contact;
